"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaEnveloppe = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utilitaires = require("../utils/utilitaires.js");

var _MfaInfoBulle = require("./MfaInfoBulle");

var _MfaPositionnement = require("../commun/MfaPositionnement");

require("../css/mfa-enveloppe.css");

var _MfaChampProprietes = require("../commun/MfaChampProprietes.js");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MfaEnveloppe = /*#__PURE__*/function (_Component) {
  _inherits(MfaEnveloppe, _Component);

  var _super = _createSuper(MfaEnveloppe);

  function MfaEnveloppe(props) {
    var _this;

    _classCallCheck(this, MfaEnveloppe);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "element", void 0);

    _defineProperty(_assertThisInitialized(_this), "margeParent", 30);

    _defineProperty(_assertThisInitialized(_this), "largeurInitiale", void 0);

    _this.obtenirNomClasse = _this.obtenirNomClasse.bind(_assertThisInitialized(_this));

    _this.ajouterEvennementFenetre();

    return _this;
  }

  _createClass(MfaEnveloppe, [{
    key: "ajouterEvennementFenetre",
    value: function ajouterEvennementFenetre() {
      var _this2 = this;

      window.addEventListener('resize', function () {
        _this2.ajusterGrandeur();
      });
    }
  }, {
    key: "ajusterGrandeur",
    value: function ajusterGrandeur() {
      var nePasAjuster = this.props.nePasAjuster;

      if (nePasAjuster === true) {
        return;
      }

      var element = this.element;
      var parent = this.obtenirParent();

      if (!(0, _utilitaires.estDefini)(parent)) {
        return;
      }

      if (this.aDAutreEnveloppeSurLaMemeRangee()) {
        element.style.width = null;
        return;
      }

      var rect = element.getBoundingClientRect();

      if (!(0, _utilitaires.estDefini)(this.largeurInitiale)) {
        this.largeurInitiale = rect.width;
      }

      var rectParent = parent.getBoundingClientRect();
      var espace = rectParent.width - (rect.left - rectParent.left);
      var largeurMaximale = espace - this.margeParent;
      element.style.width = largeurMaximale > this.largeurInitiale ? null : "".concat(largeurMaximale, "px");
    }
  }, {
    key: "aDAutreEnveloppeSurLaMemeRangee",
    value: function aDAutreEnveloppeSurLaMemeRangee() {
      var element = this.element;

      var _element$getBoundingC = element.getBoundingClientRect(),
          top = _element$getBoundingC.top;

      return (0, _utilitaires.decouper)(document.getElementsByClassName('mfa-enveloppe')).some(function (enveloppe) {
        return enveloppe !== element && enveloppe.getBoundingClientRect().top === top;
      });
    }
  }, {
    key: "obtenirLargeur",
    value: function obtenirLargeur(element) {
      var rect = element.getBoundingClientRect();
      return (0, _utilitaires.estDefini)(rect) ? rect.width : null;
    }
  }, {
    key: "obtenirParent",
    value: function obtenirParent() {
      if (!this.element) {
        return;
      }

      var parent = this.element.parentElement;

      while ((0, _utilitaires.estDefini)(parent) && (!(0, _utilitaires.nestPasNulOuVide)(parent.className) || !(0, _utilitaires.estDefini)(parent.className.match(/(^| )mfa-section($| )/))) && parent.tagName !== 'BODY') {
        parent = parent.parentElement;
      }

      return parent;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var props = this.obtenirPropsFiltrees();
      return /*#__PURE__*/_react.default.createElement("div", _extends({
        ref: function ref(element) {
          if (element) {
            _this3.element = element;
            _this3.largeurInitiale = element.getBoundingClientRect().width;

            _this3.ajusterGrandeur();
          }
        },
        className: this.obtenirNomClasse()
      }, props), this.afficherEtiquetteHaut(), (0, _utilitaires.nestPasNulOuVide)(this.props.precision) && /*#__PURE__*/_react.default.createElement("p", {
        className: "precision"
      }, this.props.precision), this.afficherContenu(), (0, _utilitaires.nestPasNulOuVide)(this.props.messageErreur) && /*#__PURE__*/_react.default.createElement("p", {
        className: "message-erreur"
      }, this.props.messageErreur));
    }
  }, {
    key: "obtenirControleEnfant",
    value: function obtenirControleEnfant() {
      var _this4 = this;

      var children = this.props.children;

      if (!(0, _utilitaires.estDefini)(children)) {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: this.obtenirClasseChaine()
        }, "\xA0");
      } else if (typeof children === 'string') {
        return this.obtenirControlChaine(children);
      } else if (children instanceof Array) {
        return children.map(function (enfant) {
          return typeof enfant === 'string' ? _this4.obtenirControlChaine(enfant) : enfant;
        });
      }

      return children;
    }
  }, {
    key: "obtenirClasseChaine",
    value: function obtenirClasseChaine() {
      var classe = "mfa-lectureseule";
      var sansRembourrage = this.props.sansRembourrage;

      if (sansRembourrage === true) {
        classe += " sans-rembourrage";
      }

      return classe;
    }
  }, {
    key: "obtenirControlChaine",
    value: function obtenirControlChaine(chaine) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: this.obtenirClasseChaine()
      }, " ", (0, _utilitaires.nestPasNulOuVide)(chaine) ? chaine : "\xa0");
    }
  }, {
    key: "obtenirNomClasse",
    value: function obtenirNomClasse() {
      var nomClasse = 'mfa-enveloppe';

      if ((0, _utilitaires.nestPasNulOuVide)(this.props.messageErreur)) {
        nomClasse += ' invalide';
      }

      if ((0, _utilitaires.nestPasNulOuVide)(this.props.taille)) {
        if (this.props.taille === 'sm') {
          nomClasse += ' largeur-sm';
        } else if (this.props.taille === 'md') {
          nomClasse += ' largeur-md';
        } else if (this.props.taille === 'lg') {
          nomClasse += ' largeur-lg';
        } else if (this.props.taille === 'xl') {
          nomClasse += ' largeur-xl';
        } else if (this.props.taille === 'xxl') {
          nomClasse += ' largeur-xxl';
        }
      }

      if ((0, _utilitaires.estDefini)(this.props.className)) {
        nomClasse += ' ' + this.props.className;
      }

      return nomClasse;
    }
  }, {
    key: "afficherEtiquette",
    value: function afficherEtiquette() {
      var indicateurAvant = '<sup>';
      var indicateurApres = '</sup>';
      var etiquette = this.props.etiquette;

      if ((0, _utilitaires.estDefini)(this.props.etiquette) && this.props.etiquette.includes(indicateurAvant) && this.props.etiquette.includes(indicateurApres)) {
        var indexAvant = etiquette.indexOf(indicateurAvant) + indicateurAvant.length;
        var indexApres = etiquette.indexOf(indicateurApres);
        var messages = etiquette.split(indicateurAvant);
        var messageGauche = messages[0];
        messages = etiquette.split(indicateurApres);
        var messageDroite = messages[1];
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: this.props.idChamp,
          className: "etiquette"
        }, messageGauche, /*#__PURE__*/_react.default.createElement("sup", null, etiquette.substring(indexAvant, indexApres)), messageDroite, this.props.estObligatoire && /*#__PURE__*/_react.default.createElement("span", {
          className: "est-obligatoire"
        }, " *"), " ", (0, _utilitaires.nestPasNulOuVide)(this.props.infoBulle) && /*#__PURE__*/_react.default.createElement(_MfaInfoBulle.MfaInfoBulle, {
          infoBulleTitre: this.props.infoBulleTitre,
          infoBulle: this.props.infoBulle
        })));
      }

      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: this.props.idChamp,
        className: "etiquette"
      }, this.props.etiquette, this.props.estObligatoire && /*#__PURE__*/_react.default.createElement("span", {
        className: "est-obligatoire"
      }, " *"), " ", (0, _utilitaires.nestPasNulOuVide)(this.props.infoBulle) && /*#__PURE__*/_react.default.createElement(_MfaInfoBulle.MfaInfoBulle, {
        infoBulleTitre: this.props.infoBulleTitre,
        infoBulle: this.props.infoBulle
      })));
    }
  }, {
    key: "afficherEtiquetteHaut",
    value: function afficherEtiquetteHaut() {
      return (0, _utilitaires.nestPasNulOuVide)(this.props.etiquette) && this.etiquetteEmplacement() === _MfaPositionnement.MfaPositionnement.Haut.toLocaleLowerCase() && this.afficherEtiquette();
    }
  }, {
    key: "afficherContenu",
    value: function afficherContenu() {
      if ((0, _utilitaires.nestPasNulOuVide)(this.props.etiquette) && this.etiquetteEmplacement() === _MfaPositionnement.MfaPositionnement.Gauche.toLocaleLowerCase()) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex flex-row flex-wrap"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "p-2"
        }, this.afficherEtiquette()), /*#__PURE__*/_react.default.createElement("div", {
          className: "p-2"
        }, this.obtenirControleEnfant()));
      }

      return this.obtenirControleEnfant();
    }
  }, {
    key: "etiquetteEmplacement",
    value: function etiquetteEmplacement() {
      var emplacement = _MfaPositionnement.MfaPositionnement.Haut;

      if ((0, _utilitaires.nestPasNulOuVide)(this.props.etiquetteEmplacement)) {
        emplacement = this.props.etiquetteEmplacement;
      }

      return emplacement.toLocaleLowerCase();
    }
  }, {
    key: "obtenirPropsFiltrees",
    value: function obtenirPropsFiltrees() {
      return (0, _utilitaires.filtrerProprietesObjet)(this.props, _MfaChampProprietes.MfaChampProprietes);
    }
  }]);

  return MfaEnveloppe;
}(_react.Component);

exports.MfaEnveloppe = MfaEnveloppe;